import {
  IDestinationEntityHandler,
  type IDestination,
} from '@principle-theorem/practice-migrations/interfaces';
import { BaseDestinationHandler } from '../destination/base-destination-handler';
import { ContactDestinationEntity } from '../exact/destination/entities/contact';
import { PatientDestinationEntity } from './destination/entities/patient';
import { PatientClinicalNoteDestinationEntity } from './destination/entities/patient-clinical-notes';
import { PatientInteractionsDestinationEntity } from './destination/entities/patient-interactions';
import { PatientInvoicesDestinationEntity } from './destination/entities/patient-invoices';
import { PatientXraysDestinationEntity } from '../exact/destination/entities/patient-xrays';
import { StafferDestinationEntity } from './destination/entities/staff';
import { ExistingPatientDestinationEntity } from '../exact/destination/entities/existing-patients';
import { PatientTreatmentPlanDestinationEntity } from './destination/entities/patient-treatment-plans';
import { PracticeWorksPatientAppointmentsDestinationEntity } from './destination/entities/patient-appointments';
import { PatientClinicalChartDestinationEntity } from './destination/entities/patient-clinical-charts';
import { PatientDocumentDestinationEntity } from './destination/entities/patient-documents';

export const PRACTICE_WORKS_DESTINATION: IDestination = {
  metadata: {
    name: 'Principle Firestore',
    description: 'Main Principle Migration',
  },
  configuration: [],
};

export class PracticeWorksDestinationHandler extends BaseDestinationHandler {
  migrationType = 'Practice Works';
  migrationVersion = 'v1';
  destination = PRACTICE_WORKS_DESTINATION;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityHandlers: IDestinationEntityHandler<any, any, any>[] = [
    new PatientDestinationEntity(),
    new StafferDestinationEntity(),
    new ContactDestinationEntity(),
    new PatientInteractionsDestinationEntity(),
    new PracticeWorksPatientAppointmentsDestinationEntity(),
    new PatientClinicalNoteDestinationEntity(),
    new PatientClinicalChartDestinationEntity(),
    new PatientInvoicesDestinationEntity(),
    new PatientDocumentDestinationEntity(),
    new PatientXraysDestinationEntity(),
    new ExistingPatientDestinationEntity(),
    new PatientTreatmentPlanDestinationEntity(),
  ];
}
